// extracted by mini-css-extract-plugin
export default {"root":"Logo_root__2Wdg5","logo":"Logo_logo__-wW5b","logo24":"Logo_logo24__pFQ6W","logo36":"Logo_logo36__DcPPV","logo48":"Logo_logo48__8RPH8"};